export enum PaymentProviderType {
  Borgun = 1,
  Valitor = 2,
  Aur = 3,
  Nets = 4,
}
